import { pipe, ReadonlyArray } from "fp";
import React from "react";
import styled from "styled-components";

import { useAction } from "~/Action";
import * as ELD from "~/ELD";
import { Sort, SortDown, SortUp } from "~/Icon";
import * as Layout from "~/Layout";
import * as Table from "~/Table";

const headers = (): readonly (readonly [string, ELD.Sort.Type.Type])[] => [
  ["Date of Submission", ELD.Sort.Type.dateOfSubmission()],
  ["Submitted By", ELD.Sort.Type.submittedBy()],
  ["Driver", ELD.Sort.Type.driver()],
  ["Date Range", ELD.Sort.Type.reportDateRange()],
  ["Sent To", ELD.Sort.Type.sentTo()],
  ["Assets", ELD.Sort.Type.assets()],
  ["Submission Status", ELD.Sort.Type.submissionStatus()],
  ["Resend", ELD.Sort.Type.resend()],
  ["Reference", ELD.Sort.Type.reference()],
];

/** Number of headers with content plus one for controls. */
export const colSpan = (): number => headers().length + 1;

export const Component = () =>
  pipe(
    ELD.Sort.useActive(),
    (active) =>
      pipe(
        headers(),
        ReadonlyArray.map(([title, sort]) => (
          <Header.Component
            key={title}
            title={title}
            sort={{ type: sort, active }}
          />
        ))
      ),
    (headers) => (
      <Table.Head.Component>
        <Table.Row.Component>{headers}</Table.Row.Component>
      </Table.Head.Component>
    )
  );

namespace Header {
  export type Header = {
    readonly title: string;
    readonly sort: Pick<ELD.Sort.Sort, "type"> & {
      readonly active: ELD.Sort.Sort;
    };
  };

  export const Component: React.Fn<Header> = ({ title, sort }) => (
    <Style onClick={useAction(ELD.Sort.Action.Updated.create(sort))}>
      {title}
      <Layout.Inline.Component left>
        <Icon.Component sort={sort} />
      </Layout.Inline.Component>
    </Style>
  );

  const Style = styled(Table.Header.Component)`
    width: ${(1 / headers().length) * 100}vw;
    cursor: pointer;
  `;

  namespace Icon {
    export const Component: React.Fn<Pick<Header, "sort">> = ({ sort }) =>
      sort.type !== sort.active.type ? (
        <Sort />
      ) : sort.active.direction === ELD.Sort.Direction.descending() ? (
        <SortDown />
      ) : (
        <SortUp />
      );
  }
}
